import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import Input from '../form/input';

import util from '../../lib/util';
import style from './style.css';

const initialState = {
    loading: false,
    view: {
        countries: false,
        languages: false,
        brands: false,
    },
};

@observer
class BrandList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...initialState,
        };
        this.updateTimer = {};

        const { brandStore } = this.props.stores;
        brandStore.list();
    }

    handleScroll = () => {
        const { loading } = this.state;
        const { brandStore } = this.props.stores;
        const { totalAppend, limit } = brandStore;
        if (window.innerHeight + document.documentElement.scrollTop + 500
            < document.documentElement.offsetHeight) return;
        if (loading) return;

        let offset = brandStore.offset;
        if (offset === 0 || totalAppend > 0) {
            offset += limit;
            clearTimeout(this.scrollLoader);
            this.scrollLoader = setTimeout(async () => {
                this.setState({ loading: true });
                brandStore.updateOffset(offset);
                await brandStore.list(true);
                this.setState({ loading: false });
            }, 500);
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    async updateField(id, field, value) {
        const { brandStore } = this.props.stores;
        brandStore.updateField(id, field, value);

        clearTimeout(this.updateTimer[field]);
        this.updateTimer[field] = setTimeout(async () => {
            this.doUpdateField(id, field, value);
        }, 500);
    }

    async doUpdateField(id, field, value) {
        const { brandStore } = this.props.stores;
        await brandStore.saveField(id, field, value);
    }

    render() {
        const { loading } = this.state;
        const { brandStore } = this.props.stores;
        const { brands, queryFilter, saved } = brandStore;

        return (
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-12'>
                        <small class='text-muted font-weight-lighter float-right mr-2'>
                            Total: {brandStore.total}<br />
                        </small>

                        <span class='float-left form-row align-items-center mr-5'>
                            <div class='col-auto'>
                                <input type='text' class='form-control form-control-sm' id='inlineFormInputName' placeholder='Search for brands...'
                                    onInput={e => brandStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true })}
                                    value={queryFilter.search}
                                />
                            </div>
                            <div class='col-auto'>
                                <button type='button' class='btn btn-sm btn-primary' onClick={() => brandStore.list()}>Search</button>
                            </div>
                        </span>
                    </div>
                </div>
                <div class='row'>
                    <div class='col-12'>

                        {queryFilter.search && <div class='w-100 text-left mt-2 mb-5'>
                            <h1><i class='fas fa-search' /> Search results</h1>
                            Found {brandStore.total} results in your search for "{queryFilter.search}".<br />
                            <button class='btn btn-sm btn-warning mt-2'
                                onClick={() => brandStore.toggleQueryfilter('search', '', { setValue: true, skipUpdate: true, setTimer: true })}
                            >
                                <i class='fas fa-times' /> Reset search
                            </button>
                        </div>}

                        <div class='table-responsive'>
                            <table class={`${style.table} table table-striped table-sm table-borderless`}>
                                <thead>
                                    {brandStore.sort !== brandStore.defaultSort && <tr>
                                        <th colspan='8'>
                                            <span class={`${style.pointerCursor} mr-2 badge badge-pill badge-secondary`} onClick={() => brandStore.resetSort()}>
                                                <i class='fas fa-times-circle' /> Reset sort
                                            </span>
                                        </th>
                                    </tr>}
                                    <tr>
                                        <th style='width: 15%'>
                                            <span class={style.pointerCursor} onClick={() => brandStore.toggleSort('name', '')}>
                                                Name {util.getSortIcon('name', brandStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 15%'>
                                            <span class={style.pointerCursor} onClick={() => brandStore.toggleSort('brandno', '')}>
                                                Brandno {util.getSortIcon('brandno', brandStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 45%'>
                                            <span class={style.pointerCursor} onClick={() => brandStore.toggleSort('fullName', '')}>
                                                Fullname {util.getSortIcon('fullName', brandStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%' class='text-right'>
                                            <span class={style.pointerCursor} onClick={() => brandStore.toggleSort('sort', '')}>
                                                Sort {util.getSortIcon('sort', brandStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%' class='text-right'>
                                            <span class={style.pointerCursor} onClick={() => brandStore.toggleSort('count', '-')}>
                                                Count {util.getSortIcon('count', brandStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 5%' class='text-right'>
                                            <span class={style.pointerCursor} onClick={() => brandStore.toggleSort('countPresale', '-')}>
                                                Count presale {util.getSortIcon('countPresale', brandStore.sort)}
                                            </span>
                                        </th>
                                        <th style='width: 10%' class='text-right'>
                                            <span class={style.pointerCursor} onClick={() => brandStore.toggleSort('updatedDate', '-')}>
                                                Updated {util.getSortIcon('updatedDate', brandStore.sort)}
                                            </span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {brands && brands.map(brand => (
                                        <tr class={`${style.tableline}`}>
                                            <td>
                                                <a href={`/brands/${brand.id}/Basics`}>{brand.name}</a>
                                            </td>
                                            <td>
                                                {brand.brandno}
                                            </td>
                                            <td>
                                                {brand.fullName}
                                            </td>
                                            <td class='text-right'>
                                                <Input
                                                    id={brand.id}
                                                    className='text-right form-control-sm'
                                                    isValid={saved[`sort.${brand.id}`]}
                                                    name='sort'
                                                    value={brand.sort}
                                                    onInput={e => this.updateField(brand.id, 'sort', e.target.value)}
                                                    hideHelp={1}
                                                />
                                            </td>
                                            <td class='text-right'>
                                                {brand.count}
                                            </td>
                                            <td class='text-right'>
                                                {brand.countPresale}
                                            </td>
                                            <td class='text-right'>
                                                {util.ffeDateTime(brand.updatedDate)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
                {loading && <div class='row'>
                    <div class='col-12 text-center'>
                        <div class='spinner-border text-success' role='status'>
                            <span class='sr-only'>Loading...</span>
                        </div>
                    </div>
                </div>}
                <div class='text-center mt-4 mb-2'>
                    <small class='text-muted'>
                        <i class='fas fa-ellipsis-h' />
                    </small>
                </div>
            </div>
        );
    }
}

export default BrandList;




// WEBPACK FOOTER //
// ./components/brands/list.js